Gift =
  init: (payload, done) ->
    @cookieDomain = payload?.giftButton?.cookieDomain

    @bindGiftButton()
    done()

  bindGiftButton: ->
    $selected = document.querySelector('.m-option-b.inline-list input:checked')
    $gift_button  = document.querySelectorAll('.gift-button')

    if $gift_button.length > 0
      $gift_button.forEach ($btn) =>
        $btn.href = "#{$selected.value}&gift=true" if $selected

        $btn.addEventListener('click', (e) =>
          @createCookie()

          if window.BuyButton?.eventBus
            e.preventDefault()
            window.BuyButton.eventBus.go 'buy_button_clicked', e
        )

  createCookie: ->
    Cookie.set('modalForGiftOnLoad','true',60, @cookieDomain)
    @cookieCreated = true

  removeCookie: ->
    Cookie.unset('modalForGiftOnLoad', @cookieDomain)
    @cookieCreated = false

module.exports = Gift
